import { Expansion, ExpansionPatch } from '../gameConfig/expansion';
import { getGameConfig } from '../gameConfig';
import { Difficulty, FeatureFlag, RaidDifficulty, WoWDifficultyId } from '../gameConfig/sharedTypes';

export const RAID_DIFFICULTIES: Difficulty[] = [
  {
    id: WoWDifficultyId.NORMAL_10,
    slug: RaidDifficulty.NORMAL_10,
    name: 'Normal 10',
    acronym: 'N10',
    maxMembers: 10
  },
  {
    id: WoWDifficultyId.NORMAL_25,
    slug: RaidDifficulty.NORMAL_25,
    name: 'Normal 25',
    acronym: 'N25',
    maxMembers: 25,
    approximateDifficulty: RaidDifficulty.NORMAL_10
  },
  {
    id: WoWDifficultyId.HEROIC_10,
    slug: RaidDifficulty.HEROIC_10,
    name: 'Heroic 10',
    acronym: 'H10',
    maxMembers: 10
  },
  {
    id: WoWDifficultyId.HEROIC_25,
    slug: RaidDifficulty.HEROIC_25,
    name: 'Heroic 25',
    acronym: 'H25',
    maxMembers: 25,
    approximateDifficulty: RaidDifficulty.HEROIC_10
  },
  {
    id: WoWDifficultyId.NORMAL_RAID,
    slug: RaidDifficulty.NORMAL,
    name: 'Normal',
    acronym: 'N',
    maxMembers: 30
  },
  {
    id: WoWDifficultyId.HEROIC_RAID,
    slug: RaidDifficulty.HEROIC,
    name: 'Heroic',
    acronym: 'H',
    maxMembers: 30
  },
  {
    id: WoWDifficultyId.MYTHIC_RAID,
    slug: RaidDifficulty.MYTHIC,
    name: 'Mythic',
    acronym: 'M',
    maxMembers: 20
  },
];

export const DIFFICULTIES_BY_SLUG = RAID_DIFFICULTIES.reduce(
  (acc, item) => {
    if (acc[item.slug]) {
      // only save the first occurrence of a slug.
      return acc;
    }
    acc[item.slug] = item;
    return acc;
  },
  {} as { [key: string]: Difficulty }
);

export type FeatureFlagMap = {
  [key in FeatureFlag]: boolean;
} & {
  params: Record<string, any>;
};

export type TFeatureFlagValues = (typeof FeatureFlag)[keyof typeof FeatureFlag];

export const enum LoggedEntityStatus {
  STARTED = 'started',
  FINISHED = 'finished',
  VALIDATED = 'validated',
  INVALID = 'invalid',
  ABORTED = 'aborted'
}

export const Expansions = {
  ...Expansion,
  FirstSupported: getGameConfig().FirstSupportedExpansion,
  Previous: getGameConfig().PreviousExpansion,
  Current: getGameConfig().CurrentExpansion,
  Next: getGameConfig().NextExpansion
};
export const Patches = {
  ...ExpansionPatch,
  Minimum: getGameConfig().FirstSupportedPatch,
  Current: getGameConfig().CurrentPatch,
  PublicTestRealm: getGameConfig().PublicTestRealmPatch,
  Beta: getGameConfig().BetaPatch
};

export const enum UserReplayPrivacy {
  PUBLIC = 'public',
  PRIVATE = 'private',
  DEFAULT = PUBLIC
}

export const enum UserAutoLinkVideoFlag {
  TWITCH = 1,
  YOUTUBE = 2,
  DOUYU = 4,

  DEFAULT = TWITCH | YOUTUBE | DOUYU
}

export enum ArticleType {
  NEWS = 'news',
  REDIRECT = 'redirect'
}
